import { __assign, __awaiter, __generator } from "tslib";
// @ts-ignore
import { AuthTypeEnum, DUMMY_BASE_URL, setSearchParams } from '@redhat-cloud-services/javascript-clients-shared/dist/common';
/**
  * @export
  * @enum {string}
  */
export var ApiHostGetHostListProviderTypeEnum = {
    Alibaba: 'alibaba',
    Aws: 'aws',
    Azure: 'azure',
    Discovery: 'discovery',
    Gcp: 'gcp',
    Ibm: 'ibm'
};
/**
  * @export
  * @enum {string}
  */
export var ApiHostGetHostListOrderByEnum = {
    DisplayName: 'display_name',
    GroupName: 'group_name',
    Updated: 'updated',
    OperatingSystem: 'operating_system',
    LastCheckIn: 'last_check_in'
};
/**
  * @export
  * @enum {string}
  */
export var ApiHostGetHostListStalenessEnum = {
    Fresh: 'fresh',
    Stale: 'stale',
    StaleWarning: 'stale_warning',
    Unknown: 'unknown'
};
/**
  * @export
  * @enum {string}
  */
export var ApiHostGetHostListRegisteredWithEnum = {
    Insights: 'insights',
    Yupana: 'yupana',
    Satellite: 'satellite',
    Discovery: 'discovery',
    Puptoo: 'puptoo',
    RhsmConduit: 'rhsm-conduit',
    CloudConnector: 'cloud-connector',
    NotYupana: '!yupana',
    NotSatellite: '!satellite',
    NotDiscovery: '!discovery',
    NotPuptoo: '!puptoo',
    NotRhsmConduit: '!rhsm-conduit',
    NotCloudConnector: '!cloud-connector'
};
/**
  * @export
  * @enum {string}
  */
export var ApiHostGetHostListSystemTypeEnum = {
    Conventional: 'conventional',
    Bootc: 'bootc',
    Edge: 'edge',
    Cluster: 'cluster'
};
var isApiHostGetHostListObjectParams = function (params) {
    var l = params.length === 1;
    if (l && typeof params[0] === 'object' && !Array.isArray(params[0])) {
        return true;
    }
    return false;
};
/**
* Read the entire list of all hosts available to the account. <br /><br /> Required permissions: inventory:hosts:read
* @summary Read the entire list of hosts
* @param {ApiHostGetHostListParams} config with all available params.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export var apiHostGetHostListParamCreator = function (sendRequest) {
    var config = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        config[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var params, displayName, fqdn, hostnameOrId, insightsId, subscriptionManagerId, providerId, providerType, updatedStart, updatedEnd, lastCheckInStart, lastCheckInEnd, groupName, branchId, perPage, page, orderBy, orderHow, staleness, tags, registeredWith, systemType, filter, fields, _a, options, localVarPath, localVarUrlObj, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, args;
        return __generator(this, function (_b) {
            params = isApiHostGetHostListObjectParams(config) ? config[0] : ['displayName', 'fqdn', 'hostnameOrId', 'insightsId', 'subscriptionManagerId', 'providerId', 'providerType', 'updatedStart', 'updatedEnd', 'lastCheckInStart', 'lastCheckInEnd', 'groupName', 'branchId', 'perPage', 'page', 'orderBy', 'orderHow', 'staleness', 'tags', 'registeredWith', 'systemType', 'filter', 'fields', 'options'].reduce(function (acc, curr, index) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[curr] = config[index], _a)));
            }, {});
            displayName = params.displayName, fqdn = params.fqdn, hostnameOrId = params.hostnameOrId, insightsId = params.insightsId, subscriptionManagerId = params.subscriptionManagerId, providerId = params.providerId, providerType = params.providerType, updatedStart = params.updatedStart, updatedEnd = params.updatedEnd, lastCheckInStart = params.lastCheckInStart, lastCheckInEnd = params.lastCheckInEnd, groupName = params.groupName, branchId = params.branchId, perPage = params.perPage, page = params.page, orderBy = params.orderBy, orderHow = params.orderHow, staleness = params.staleness, tags = params.tags, registeredWith = params.registeredWith, systemType = params.systemType, filter = params.filter, fields = params.fields, _a = params.options, options = _a === void 0 ? {} : _a;
            localVarPath = "/hosts";
            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            localVarRequestOptions = __assign({ method: 'GET' }, options);
            localVarHeaderParameter = {};
            localVarQueryParameter = {};
            if (displayName !== undefined) {
                localVarQueryParameter['display_name'] = displayName;
            }
            if (fqdn !== undefined) {
                localVarQueryParameter['fqdn'] = fqdn;
            }
            if (hostnameOrId !== undefined) {
                localVarQueryParameter['hostname_or_id'] = hostnameOrId;
            }
            if (insightsId !== undefined) {
                localVarQueryParameter['insights_id'] = insightsId;
            }
            if (subscriptionManagerId !== undefined) {
                localVarQueryParameter['subscription_manager_id'] = subscriptionManagerId;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (providerType !== undefined) {
                localVarQueryParameter['provider_type'] = providerType;
            }
            if (updatedStart !== undefined) {
                localVarQueryParameter['updated_start'] = (updatedStart instanceof Date) ?
                    updatedStart.toISOString() :
                    updatedStart;
            }
            if (updatedEnd !== undefined) {
                localVarQueryParameter['updated_end'] = (updatedEnd instanceof Date) ?
                    updatedEnd.toISOString() :
                    updatedEnd;
            }
            if (lastCheckInStart !== undefined) {
                localVarQueryParameter['last_check_in_start'] = (lastCheckInStart instanceof Date) ?
                    lastCheckInStart.toISOString() :
                    lastCheckInStart;
            }
            if (lastCheckInEnd !== undefined) {
                localVarQueryParameter['last_check_in_end'] = (lastCheckInEnd instanceof Date) ?
                    lastCheckInEnd.toISOString() :
                    lastCheckInEnd;
            }
            if (groupName) {
                localVarQueryParameter['group_name'] = groupName;
            }
            if (branchId !== undefined) {
                localVarQueryParameter['branch_id'] = branchId;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (orderHow !== undefined) {
                localVarQueryParameter['order_how'] = orderHow;
            }
            if (staleness) {
                localVarQueryParameter['staleness'] = staleness;
            }
            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }
            if (registeredWith) {
                localVarQueryParameter['registered_with'] = registeredWith;
            }
            if (systemType) {
                localVarQueryParameter['system_type'] = systemType;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            args = {
                urlObj: localVarUrlObj,
                options: localVarRequestOptions,
                auth: [
                    {
                        // authentication ApiKeyAuth required
                        // in header with key required
                        authType: AuthTypeEnum.InHeader,
                        authKey: "x-rh-identity"
                    }
                ]
            };
            return [2 /*return*/, sendRequest(Promise.resolve(args))];
        });
    });
};
export default apiHostGetHostListParamCreator;
//# sourceMappingURL=index.js.map